import { QueryKeys } from '../queryKeys';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppDataContext } from '../../contexts/appData';
import { useLocation } from 'react-router-dom';

export const useGetProductAnalyticsTotal = ({ productId }) => {
  const { api } = useContext(AppDataContext);
  const { search } = useLocation()
  const { Page, Limit, ...query } = Object.fromEntries(new URLSearchParams(search));
  const queryString = new URLSearchParams(query).toString();

  const { data, refetch, isLoading, isPending, isFetching } = useQuery({
    queryKey: [QueryKeys.ProductAnalyticsTotal, productId],
    queryFn: () => api.getProductAnalyticsTotal(productId, queryString),
    staleTime: 1000 * 60 * 60,
    placeholderData: (previousData) => previousData,
  });

  const total = data?.data.total;
  const sellStatistics = data?.data.sell_statistics;
  const ranking = data?.data.ranking;
  const product = data?.data?.data
  const nextProductId = data?.data?.next;
  const prevProductId = data?.data?.previous;

  return { isLoading, refetch, isPending, isFetching, total, sellStatistics, ranking, product, nextProductId, prevProductId };
};
